import React, { useEffect } from "react";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";

const Error404 = () => {
  const route = all_routes;

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "404 - Page Not Found | Khelo Indore";
  }, []);

  return (
    <div>
      {/* Main Wrapper */}
      <div className="main-wrapper error-page">
        {/* Page Content */}
        <div className="content ellipses">
          <div className="container">
            <header className="text-center mt-0 mb-4">
              <Link to={route.home}>
                <img
                  src="/logo.png"
                  className="img-fluid"
                  alt="Khelo Indore"
                  style={{ maxHeight: "60px", width: "auto" }}
                />
              </Link>
            </header>
            <div className="errors-img">
              <ImageWithBasePath
                src="assets/img/404.png"
                className="img-fluid"
                alt="404 Page Not Found"
              />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-6 col-lg-5 mx-auto text-center">
                <h3 className="mb-2">
                  404 - Page Not Found
                </h3>
                <p className="mb-4 text-muted">
                  The page you are looking for does not exist, has been removed, or is temporarily unavailable.
                </p>
                <Link
                  to={route.home}
                  className="btn btn-primary d-inline-flex align-items-center"
                >
                  Go to Home
                  <i className="feather-arrow-right-circle ms-2" />
                </Link>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
      {/* /Main Wrapper */}
    </div>
  );
};

export default Error404;
